import { useCallback } from 'react'
import type { RouterInputs } from '@klear/ui/lib/trpc'
import { trpc } from '@klear/ui/lib/trpc'

export function usePurchaseOrderMutations() {
  const createMutation = trpc.purchaseOrder.create.useMutation()
  const updateMutation = trpc.purchaseOrder.update.useMutation()

  const createPurchaseOrder = useCallback(
    (input: RouterInputs['purchaseOrder']['create']) => createMutation.mutateAsync(input),
    [createMutation.mutateAsync]
  )

  const updatePurchaseOrder = useCallback(
    (input: RouterInputs['purchaseOrder']['update']) => updateMutation.mutateAsync(input),
    [updateMutation.mutateAsync]
  )

  return {
    createPurchaseOrder,
    updatePurchaseOrder,
    isSaving: createMutation.isPending || updateMutation.isPending
  }
}
